import { connect } from "react-redux";
import { storesReady } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas/actions";
import { AUTH_GET_TOKEN } from "redux-store/auth/actions";
import * as Auth from "redux-store/auth/selectors";
import { LoginPage } from "view/auth/login";
import { getAppName } from "view/auth/utils";

function mapStateToProps(state) {
  const auth = Auth.authSelector(state);
  const sessionExpired = Auth.isSessionExpired(auth);
  const storesLoaded = storesReady(state.global.auth);
  const isAuthenticated = Auth.isAuthenticated(auth);

  return {
    isAuthenticated,
    sessionExpired,
    storesLoaded,
    enablePasswordRecovery: true,
    title: getAppName(),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLogin: (email, password) => {
      return createPromiseApiAction(dispatch, AUTH_GET_TOKEN, [
        email,
        password,
      ]);
    },
  };
}

const ConnectedLoginPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPage);

export { ConnectedLoginPage };
